import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
var __default__ = {
  name: "GradeIndex"
};
import { ref } from "vue";
import { useStore } from "vue2-helpers/vuex";
import { getData, createData } from "@/services/axios";
import sortableList from "@/components/common/SortableList.vue";
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    // @ts-check
    var _storeToRefs = storeToRefs(useGradeClassroomStore()),
        grades = _storeToRefs.grades,
        classrooms = _storeToRefs.classrooms;

    var store = useStore();
    var isLoading = ref(true);
    var gradeSortList = ref([]);

    var setData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 初期取得時からgradeが既に変更されている可能性も考えて取得しなおす
                isLoading.value = true;
                _context.prev = 1;
                _context.next = 4;
                return getData("grades?with=classroom");

              case 4:
                data = _context.sent;
                store.dispatch("commitGrade", data.items);
                grades.value = data.items;
                gradeSortList.value = structuredClone(data.items);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);

              case 13:
                isLoading.value = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      return function setData() {
        return _ref2.apply(this, arguments);
      };
    }();

    var saveOrder = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isLoading.value = true;
                _context2.prev = 1;
                _context2.next = 4;
                return createData("writer/write_grade_index", {
                  grades: gradeSortList.value
                });

              case 4:
                _context2.next = 6;
                return getData(["grades?with=classroom", "reader/get_classroom_with_students_count"]);

              case 6:
                data = _context2.sent;
                store.dispatch("commitGrade", data[0].items);
                grades.value = data[0].items;
                gradeSortList.value = structuredClone(data[0].items);
                store.dispatch("commitClassroom", data[1].items);
                classrooms.value = data[1].items;
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](1);
                console.log(_context2.t0);

              case 17:
                isLoading.value = false;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 14]]);
      }));

      return function saveOrder() {
        return _ref3.apply(this, arguments);
      };
    }();

    var cancelOrder = function cancelOrder() {
      setData();
    }; // created


    setData();
    expose({
      grades: grades,
      gradeSortList: gradeSortList,
      setData: setData
    });
    return {
      __sfc: true,
      grades: grades,
      classrooms: classrooms,
      store: store,
      isLoading: isLoading,
      gradeSortList: gradeSortList,
      setData: setData,
      saveOrder: saveOrder,
      cancelOrder: cancelOrder,
      sortableList: sortableList
    };
  }
});